/* ==========================================
   CONFIGURAÇÃO CENTRAL DAS MEDIDAS
========================================== */

function ymGetTabelaMedidas() {

  const config = document.querySelector(
    '[data-ym-medidas-config]'
  );

  if (!config) {
    console.warn('Configuração de medidas não encontrada.');
    return [];
  }

  try {

    return JSON.parse(config.textContent);

  } catch (error) {

    console.error(
      'Erro ao carregar tabela de medidas:',
      error
    );

    return [];
  }

}


/* ==========================================
   CRIAR TABELAS AUTOMATICAMENTE
========================================== */

function ymFormatRange(range) {

  if (!range) return '';

  return `${range.min}–${range.max} cm`;
}


function ymRenderTable(table, type, medidas) {

  let columns = [];

  if (type === 'top') {

    columns = [
      {
        key: 'tamanho',
        label: 'Tamanho'
      },
      {
        key: 'numeracao',
        label: 'Numeração'
      },
      {
        key: 'busto',
        label: 'Busto'
      }
    ];

  }

  if (type === 'bottom') {

    columns = [
      {
        key: 'tamanho',
        label: 'Tamanho'
      },
      {
        key: 'numeracao',
        label: 'Numeração'
      },
      {
        key: 'cintura',
        label: 'Cintura'
      },
      {
        key: 'quadril',
        label: 'Quadril'
      }
    ];

  }

  if (type === 'body') {

    columns = [
      {
        key: 'tamanho',
        label: 'Tamanho'
      },
      {
        key: 'numeracao',
        label: 'Numeração'
      },
      {
        key: 'busto',
        label: 'Busto'
      },
      {
        key: 'cintura',
        label: 'Cintura'
      },
      {
        key: 'quadril',
        label: 'Quadril'
      }
    ];

  }


  /* CABEÇALHO */

  const header = `

    <tr>

      ${columns
        .map(column => `<th>${column.label}</th>`)
        .join('')}

    </tr>

  `;


  /* LINHAS */

  const rows = medidas
    .map(item => {

      return `

        <tr>

          ${columns
            .map(column => {

              let value = item[column.key];

              if (
                column.key === 'busto' ||
                column.key === 'cintura' ||
                column.key === 'quadril'
              ) {

                value = ymFormatRange(value);

              }

              return `<td>${value ?? ''}</td>`;

            })
            .join('')}

        </tr>

      `;

    })
    .join('');


  table.innerHTML = header + rows;
}


function ymRenderTables(wrapper) {

  if (!wrapper) return;

  const medidas = ymGetTabelaMedidas();

  if (!medidas.length) return;

  const tables = wrapper.querySelectorAll(
    '[data-ym-table]'
  );

  tables.forEach(table => {

    const type = table.dataset.ymTable;

    ymRenderTable(
      table,
      type,
      medidas
    );

  });

}


/* ==========================================
   ABAS PRINCIPAIS
========================================== */

(function(){

  function animate(container){

    const blocos = container.querySelectorAll(
      '.ym-bloco'
    );

    blocos.forEach(
      b => b.classList.remove('show')
    );

    void container.offsetHeight;

    blocos.forEach((b, i) => {

      setTimeout(
        () => b.classList.add('show'),
        i * 120
      );

    });

  }


  function init(){

    const wrapper = document.querySelector(
      '.ym-wrapper'
    );

    if(!wrapper) return;


    /* CRIA AS TABELAS */

    ymRenderTables(wrapper);


    const tabs = wrapper.querySelectorAll(
      '.ym-tab'
    );

    const contents = wrapper.querySelectorAll(
      '.ym-content'
    );


    tabs.forEach(tab => {

      tab.addEventListener('click', function(){

        tabs.forEach(
          t => t.classList.remove('active')
        );

        contents.forEach(
          c => c.classList.remove('active')
        );


        this.classList.add('active');


        const el = wrapper.querySelector(
          `[data-content="${this.dataset.tab}"]`
        );


        if(el){

          el.classList.add('active');

          animate(el);

        }

      });

    });


    /* ==========================================
       GUIA
    ========================================== */

    const guideTabs = wrapper.querySelectorAll(
      '.ym-guide-tab'
    );

    const guideContents = wrapper.querySelectorAll(
      '.ym-guide-content'
    );


    guideTabs.forEach(tab => {

      tab.addEventListener('click', function(){

        guideTabs.forEach(
          t => t.classList.remove('active')
        );

        guideContents.forEach(
          c => c.classList.remove('active')
        );


        this.classList.add('active');


        const el = wrapper.querySelector(
          `[data-guide-content="${this.dataset.guide}"]`
        );


        if(el){

          el.classList.add('active');

        }

      });

    });


    const active = wrapper.querySelector(
      '.ym-content.active'
    );


    if(active){

      animate(active);

    }

  }


  document.addEventListener(
    'DOMContentLoaded',
    init
  );

})();



/* ==========================================
   POPUP STEP-BY-STEP
========================================== */

(function(){

  let stepIndex = 0;

  const steps = [
    "busto",
    "cintura",
    "quadril"
  ];


  let data = {
    busto: null,
    cintura: null,
    quadril: null
  };


  const popup = document.getElementById(
    "ym-popup"
  );


  /* EVITA POPUP ABERTO NO CARREGAMENTO */

  if(popup){

    popup.classList.remove(
      "active"
    );

  }


  /* ==========================================
     CLIQUES
  ========================================== */

  document.addEventListener(
    "click",
    function(e){

      /* ABRIR POPUP */

      if(
        e.target.closest(
          ".ym-discover-btn"
        )
      ){

        openPopup();

      }


      /* FECHAR */

      if(
        e.target.closest(
          ".ym-popup-close"
        ) ||
        e.target.classList.contains(
          "ym-popup-overlay"
        )
      ){

        closePopup();

      }


      /* PRÓXIMO */

      if(
        e.target.closest(
          ".ym-next"
        )
      ){

        if(!validate()) return;


        save();

        stepIndex++;


        if(
          stepIndex < steps.length
        ){

          render();

        } else {

          showResult();

        }

      }


      /* REFAZER */

      if(
        e.target.closest(
          ".ym-restart"
        )
      ){

        reset();

        render();

      }

    }
  );


  /* ==========================================
     ABRIR
  ========================================== */

  function openPopup(){

    if(!popup) return;


    popup.classList.add(
      "active"
    );


    document.body.style.overflow =
      "hidden";


    reset();

    render();

  }


  /* ==========================================
     FECHAR
  ========================================== */

  function closePopup(){

    if(!popup) return;


    popup.classList.remove(
      "active"
    );


    document.body.style.overflow =
      "";

  }


  /* ==========================================
     RENDER DA PERGUNTA
  ========================================== */

  function render(){

    const field =
      steps[stepIndex];


    const container =
      document.querySelector(
        ".ym-inputs"
      );


    const title =
      document.querySelector(
        '[data-step="2"] .ym-step-title'
      );


    if(
      !container ||
      !title
    ) return;


    let label = "";


    if(field === "busto"){

      label =
        "Qual seu busto? (cm)";

    }


    if(field === "cintura"){

      label =
        "Qual sua cintura? (cm)";

    }


    if(field === "quadril"){

      label =
        "Qual seu quadril? (cm)";

    }


    title.innerText = label;


    container.innerHTML = `

      <input
        type="number"
        class="ym-field"
        placeholder="Ex: 90"
        min="1"
        step="0.1"
      >

      <span class="ym-error">
        Preencha corretamente
      </span>

    `;


    setTimeout(() => {

      document
        .querySelector(
          ".ym-field"
        )
        ?.focus();

    }, 100);

  }


  /* ==========================================
     VALIDAÇÃO
  ========================================== */

  function validate(){

    const input =
      document.querySelector(
        ".ym-field"
      );


    const error =
      document.querySelector(
        ".ym-inputs .ym-error"
      );


    if(
      !input ||
      !error
    ){

      return false;

    }


    const value =
      parseFloat(
        input.value
      );


    if(
      !value ||
      value <= 0
    ){

      input.classList.add(
        "error"
      );


      error.classList.add(
        "active"
      );


      return false;

    }


    input.classList.remove(
      "error"
    );


    error.classList.remove(
      "active"
    );


    return true;

  }


  /* ==========================================
     SALVAR MEDIDA
  ========================================== */

  function save(){

    const input =
      document.querySelector(
        ".ym-field"
      );


    if(!input) return;


    data[
      steps[stepIndex]
    ] = parseFloat(
      input.value
    );

  }


  /* ==========================================
     DISTÂNCIA ATÉ A FAIXA
  ========================================== */

  function rangeDistance(
    value,
    range
  ){

    if(
      value < range.min
    ){

      return (
        range.min - value
      );

    }


    if(
      value > range.max
    ){

      return (
        value - range.max
      );

    }


    /* ESTÁ DENTRO DA FAIXA */

    return 0;

  }


  /* ==========================================
     RESULTADO
  ========================================== */

  function showResult(){

    const tabela =
      ymGetTabelaMedidas();


    if(!tabela.length){

      console.warn(
        "Tabela de medidas vazia."
      );

      return;

    }


    const {
      busto,
      cintura,
      quadril
    } = data;


    let melhor =
      tabela[0];


    let menorErro =
      Infinity;


    tabela.forEach(item => {

      const erroBusto =
        rangeDistance(
          busto,
          item.busto
        );


      const erroCintura =
        rangeDistance(
          cintura,
          item.cintura
        );


      const erroQuadril =
        rangeDistance(
          quadril,
          item.quadril
        );


      const erroTotal =
        erroBusto +
        erroCintura +
        erroQuadril;


      if(
        erroTotal <
        menorErro
      ){

        menorErro =
          erroTotal;


        melhor =
          item;

      }

    });


    const resultEl =
      document.querySelector(
        ".ym-result"
      );


    if(resultEl){

      resultEl.innerText =
        melhor.tamanho;

    }


    const step2 =
      document.querySelector(
        '[data-step="2"]'
      );


    const step3 =
      document.querySelector(
        '[data-step="3"]'
      );


    if(step2){

      step2.style.display =
        "none";

    }


    if(step3){

      step3.style.display =
        "block";

    }

  }


  /* ==========================================
     RESET
  ========================================== */

  function reset(){

    stepIndex = 0;


    data = {
      busto: null,
      cintura: null,
      quadril: null
    };


    const step2 =
      document.querySelector(
        '[data-step="2"]'
      );


    const step3 =
      document.querySelector(
        '[data-step="3"]'
      );


    if(step2){

      step2.style.display =
        "block";

    }


    if(step3){

      step3.style.display =
        "none";

    }

  }

})();



/* ==========================================
   WHATSAPP
========================================== */

document.addEventListener(
  "click",
  function(e){

    const btn =
      e.target.closest(
        ".ym-whatsapp-trigger"
      );


    if(!btn) return;


    const overlay =
      document.getElementById(
        "pw-overlay"
      );


    const drawer =
      document.getElementById(
        "pw-drawer"
      );


    if(
      overlay &&
      drawer
    ){

      overlay.style.display =
        "block";


      drawer.classList.add(
        "open"
      );

    }

  }
);